export default __webpack_public_path__ + "10379a1cb108d66ddb5a6e6094d02447.png";